import { useRef, useEffect } from 'react';
import styles from './DropDownResults.module.css';
import { SelectedItem, MultiSelectDropDownOption } from './types';
import { SelectionType } from './constants';
import DropDownOption from './DropDownOption';

interface GroupedOptionsProps {
  options: Record<string, MultiSelectDropDownOption[]>;
  selectedItems: SelectedItem[];
  onItemSelect: (value: string, group?: string, type?: SelectionType, label?: string) => void;
  focusedIndex: number;
}

const GroupedOptions = ({
  options,
  selectedItems,
  onItemSelect,
  focusedIndex,
}: GroupedOptionsProps) => {
  const focusedElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focusedElementRef.current) {
      focusedElementRef.current.scrollIntoView({ block: 'nearest' });
    }
  }, [focusedIndex]);

  const getItemStatus = (id: string) => {
    return selectedItems.find((item) => item.value === id);
  };

  let currentIndex = 0;

  return (
    <div className={styles.groupedOptions}>
      {Object.entries(options).map(([group, items]) => (
        <div key={group} className={styles.group}>
          <div className={styles.groupHeader}>{group}</div>
          <div className={styles.groupItems}>
            {items.map((option) => {
              const status = getItemStatus(option.id);
              const isFocused = currentIndex === focusedIndex;
              const optionIndex = currentIndex;
              currentIndex++;
              return (
                <DropDownOption
                  key={`${group}-${option.id}-${option.value}`}
                  ref={isFocused ? focusedElementRef : null}
                  option={option}
                  status={status}
                  isFocused={isFocused}
                  onItemSelect={onItemSelect}
                  group={group}
                  optionIndex={optionIndex}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GroupedOptions;
